export default {"src":"/_next/static/image/public/images/social_tiktok_white.088e9c13155665728becabe7eaf668b7.svg","height":14,"width":13};